export const GET_ADVERSE_EVENT_LIST_DATA = 'GET_ADVERSE_EVENT_LIST_DATA'
export const SET_ADVERSE_EVENT_LIST_LOADING = 'SET_ADVERSE_EVENT_LIST_LOADING'
export const GET_ADVERSE_EVENT_SUBSTANCE_DATA = 'GET_ADVERSE_EVENT_SUBSTANCE_DATA'
export const SET_ADVERSE_EVENT_SUBSTANCE_LOADING = 'SET_ADVERSE_EVENT_SUBSTANCE_LOADING'
export const CLEAR_ADVERSE_EVENT_SUBSTANCE_DATA = 'CLEAR_ADVERSE_EVENT_SUBSTANCE_DATA'
export const CLEAR_ADVERSE_EVENT_LIST_DATA = 'CLEAR_ADVERSE_EVENT_LIST_DATA'
export const CLEAR_ADVERSE_EVENT_DATA = 'CLEAR_ADVERSE_EVENT_DATA'
export const SET_CURRENT_ADVERSE_EVENT = 'SET_CURRENT_ADVERSE_EVENT'
export const DELETE_ADVERSE_EVENT = 'DELETE_ADVERSE_EVENT'
